// branch components
import AppReservationsPerHourDayEditor from '../AppReservationsPerHourDayEditor/AppReservationsPerHourDayEditor';

// components
import Modal from '@drivesally/sally-ui/lib/components/Modal/Modal';

// date constants
import DAYS_OF_WEEK from '../../../date/constants/daysOfWeek.constant.date';

// layout components
import CompactDataRow from '../../../layout/components/CompactDataRow/CompactDataRow';

// propTypes
import PropTypes from 'prop-types';

// react
import React from 'react';

const BranchAppReservationsPerHourModal = ({
  defaultReservationsPerHour,
  onSave,
  onChange,
  onClose,
  override,
  saveLabel,
  saving,
  visible,
}) => (
  <Modal
    title="Per Hour App Reservations"
    visible={visible}
    onClose={onClose}
    buttonsRight={[
      {label: saveLabel || 'Save', loading: saving, onClick: onSave},
    ]}
  >
    {(Content) => (
      <Content padding="none" noBorder>
        <CompactDataRow label="Default">
          {`Hours without an override allow ${defaultReservationsPerHour ??
            '-'} app reservation(s), set by # of App Reservations per Hour`}
        </CompactDataRow>
        {[...DAYS_OF_WEEK].map((day) => (
          <AppReservationsPerHourDayEditor
            day={day}
            key={day}
            hours={override?.[day] || {}}
            onChange={(hours) => onChange({...override, [day]: hours})}
          />
        ))}
      </Content>
    )}
  </Modal>
);

BranchAppReservationsPerHourModal.propTypes = {
  defaultReservationsPerHour: PropTypes.number,
  onSave: PropTypes.func,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  override: PropTypes.object,
  saveLabel: PropTypes.string,
  saving: PropTypes.bool,
  visible: PropTypes.bool,
};

export default BranchAppReservationsPerHourModal;
